import { supabase } from '@/lib/supabase'
import { useQuery } from '@tanstack/react-query'

export function useHouseholdId() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth', 'session'],
    queryFn: () => supabase.auth.getSession().then(({ data: { session } }) => session),
    staleTime: Infinity,
  })

  // household_id is a custom claim in the JWT access token payload (added by Postgres auth hook)
  // It is NOT in user_metadata — must be read by decoding the access token.
  // JWTs use base64url encoding — normalise to standard base64 before atob().
  let householdId: string | null = null
  if (data?.access_token) {
    try {
      const b64 = data.access_token.split('.')[1]
        .replace(/-/g, '+').replace(/_/g, '/')
      const payload = JSON.parse(atob(b64))
      householdId = (payload.household_id as string | undefined) ?? null
    } catch {
      householdId = null
    }
  }

  return { householdId, isLoading }
}
